import { User } from 'types'

type HasUsers<K extends string> = {
  [k in K]: User[]
}

type HasEntityThatHasUsers<OuterK extends string, InnerK extends string> = {
  [outer in OuterK]: Array<HasUsers<InnerK>>
}

type SelectorCallback<OuterK extends string, InnerK extends string> = (
  context: [HasEntityThatHasUsers<OuterK, InnerK>, unknown],
) => User[]

export function createUserSelectorCallback<
  OuterK extends string,
  InnerK extends string
>(
  collectionEntity: OuterK,
  userType: InnerK,
): SelectorCallback<OuterK, InnerK> {
  return context => {
    const rawUsers = context[0][collectionEntity].flatMap(
      item => item[userType],
    )

    const uniqueUsers: User[] = []
    const map = new Map()

    rawUsers.forEach((user: User) => {
      if (!map.has(user.id)) {
        map.set(user.id, true)
        uniqueUsers.push(user)
      }
    })

    return uniqueUsers
  }
}
